<template>
  <div>
    <el-form ref="claim" :model="item" label-width="120px" :label-position="labelPosition" size="small"
      v-loading="loading">
      <div class="col-12" style="text-align: right">
        
        <el-button size="small" type="danger" v-if="(claimStatus < 162) && (claimStatus !== 153)"
          @click="openDialog">
          <i class="fa-solid fa-rotate-left"></i>
          {{$t('İcraçıya_geri_qaytar')}}
        </el-button>
        <el-button size="small" v-if="payment && payment.status === 1" type="success" @click="onFinishPay">  
          {{$t('Ödənişi_yekulaşdır')}}
        </el-button>
      </div>
      <el-tabs v-model="activeName" plane>
        <el-tab-pane name="descr" :label="$t('Məlumat')">
          <card>
            <div class="row">
              <div class="col-10" style="margin-bottom: 10px;">
                <el-button type="warning" size="small" @click="onStartPay" v-if="!payment">
                  <i class="fa-solid fa-play"></i>
                  {{$t('Qəbul_et_və_başla')}}
                </el-button>
                <div v-else>
                  <span style="background-color:#8E9A9B; color: white; padding:5px;">
                    {{ "Ödəniş başlanılmışdır: " + (payment.createdBy || '') }}
                  </span><br />
                </div>
              </div>
            </div>
            <card v-if="claimStatus === 153">
              <div>
                <h4>{{$t('Geri qaytarılıb')}}</h4>
                <br>
                <el-timeline>
                  <el-timeline-item v-for="(activity, index) in rejectClaim" :key="index" :icon="activity.icon"
                    :type="activity.type" :color="'#B3005E'" :size="activity.size" 
                    :timestamp="formatDateTime(activity.createDate)">
                    <span style="font-size:11pt;">
                      {{$t('Geri_qaytaran')}} : 
                    </span>{{ activity.createUserName || '' }}
                    <br>
                    <span style="font-size:11pt;">{{$t('Səbəb')}}: </span>{{ activity.reason || '' }}
                  </el-timeline-item>
                </el-timeline>
              </div>
            </card>
            <el-collapse value="4" v-loading="loading">
              <el-collapse-item name="4">
                <template #title>
                  <div style="margin-left: 7px;">
                    <i class="fa-solid fa-circle-info"></i>
                    &nbsp;
                    <span>{{$t('Hadisə_məlumatları')}}</span>
                  </div>
                </template>
                <card>
                  <el-form disabled label-width="200px" :label-position="labelPosition" size="small"
                    v-loading="claimLoading">
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <el-form-item :label="$t('ZBT')" v-if="item.policyType && item.policyType === 1" prop="zbt">
                          <el-radio-group @change="radioChange('zbt')"
                            :disabled="item.commChainAccident === 1 || item.commInjured === 1" v-model="item.zbt">
                            <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                            <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('Zəncirvari_qəza')" v-if="item.policyType && item.policyType === 1"
                          prop="chainAccident">
                          <el-radio-group @change="radioChange('chainAccident')" :disabled="item.zbt === 1"
                            v-model="item.chainAccident">
                            <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                            <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('Xəsarət_alan')" v-if="item.policyType && item.policyType === 1"
                          prop="injured">
                          <el-radio-group @change="radioChange('injured')" :disabled="item.zbt === 1"
                            v-model="item.injured">
                            <el-radio :label="1">{{$t('Var')}}</el-radio>
                            <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('Daxili_protokol')" v-if="item.policyType && item.policyType === 1"
                          prop="protocol">
                          <el-radio-group @change="radioChange('protocol')" :disabled="item.commInjured === 1"
                            v-model="item.protocol">
                            <el-radio :label="1">{{$t('Bəli')}}</el-radio>
                            <el-radio :label="0">{{$t('Xeyr')}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('Subroqasiya')" prop="subragation">
                          <el-radio-group @change="radioChange('subragation')" v-model="item.subragation">
                            <el-radio :label="1">{{$t('Var')}}</el-radio>
                            <el-radio :label="0">{{$t('Yoxdur')}}</el-radio>
                          </el-radio-group>
                        </el-form-item>
                        <el-form-item :label="$t('F4_verilmə_tarixi')" v-if="oSdamageType !== 2 && item.policyType === 1"
                          disabled prop="f4IssueDate">
                          <el-date-picker type="date" :placeholder="$t('F4_verilmə_tarixi')" v-model="item.f4IssueDate"
                            style="width: 100%"></el-date-picker>
                        </el-form-item>
                      </div>
                      <div class="col-md-6 col-12">
                        <el-form-item v-if="(item.paymentSum || item.paymentSum !== 0) && item.damageCategoryId !== 2"
                          :label="$t('Zərərçəkən_hər_iki_tərəf')" prop="bothVictim">
                          <el-checkbox :true-label="1" :false-label="0" v-model="item.bothVictim"></el-checkbox>
                        </el-form-item>
                        <el-form-item :label="$t('NV_sayı')" v-if="item.policyType && item.policyType === 1"
                          prop="vehicleCount">
                          <el-input-number :disabled="item.zbt === 1" v-model="item.vehicleCount" :min="1" :max="10" />
                        </el-form-item>
                        <el-form-item :label="$t('Hadisənin_səbəbi')" prop="damageCategoryId">
                          <damage-categories :damageType="claimParticipants.osDamageType"
                            v-model="item.damageCategoryId" />
                        </el-form-item>
                        <el-form-item :label="$t('Xəsarətin_dərəcəsi')" prop="medDamageType"
                          v-if="item.damageCategoryId === 2">
                          <med-damage-types v-model="item.medDamageType" />
                        </el-form-item>
                      </div>
                    </div>
                    <titles :text="$t('Faydalanan')"></titles>
                    <hr width="100%" size="50"
                      style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;" align="center">
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <div style="display: flex;">
                          <div style="flex: 1; margin-right:-100px;">
                            <el-form-item>
                              <el-radio-group v-model="item.paymentPersonType">
                                <el-radio :label="1">{{$t('FİN')}}</el-radio>
                                <el-radio :label="2">{{$t('VÖEN')}}</el-radio>
                              </el-radio-group>
                            </el-form-item>
                          </div>
                          <div style="flex: 1.2">
                            <el-form-item prop="paymentIdentNumber">
                              <el-input id="search" v-model="item.paymentIdentNumber" style="width: 100%;">
                                <span slot="append">&nbsp;</span>
                                <el-button class="primary" size="small" slot="append" icon="el-icon-search"
                                  @click="item.paymentPersonType === 1 ? onSearchAsan('PersonalInfo') : onSearchAsan('VoenInfo')">
                                </el-button>
                              </el-input>
                            </el-form-item>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6 col-12">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <el-form-item :label="$t('Faydalanan_şəxs')" prop="paymentReceivedPerson">
                          <el-input v-model="item.paymentReceivedPerson"></el-input>
                        </el-form-item>
                      </div>
                      <div class="col-md-6 col-12">
                        <el-form-item :label="$t('Faydalananın_əlaqə_№')" prop="paymentReceivedPersonPhone">
                          <phone v-model="item.paymentReceivedPersonPhone" />
                        </el-form-item>
                      </div>
                    </div>
                    <titles v-if="item.damageCategoryId !== 1 && item.policyType === 1" :text="$t('Xəsarət_alan')"></titles>
                    <hr v-if="item.damageCategoryId !== 1 && item.policyType === 1" width="100%" size="50"
                      style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;" align="center">
                    <div class="row" v-if="item.policyType === 1">
                      <div class="col-md-6 col-12">
                        <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                          ::label="$t('getIdentLabelName')" prop="identNumber">
                          <el-input id="search" v-model="item.partIdentNumber" style="width: 100%;">
                            <span slot="append">&nbsp;</span>
                            <el-button class="primary" size="small" slot="append" icon="el-icon-search"
                              @click="onSearchPersonalInfo">
                            </el-button>
                          </el-input>
                        </el-form-item>
                      </div>
                      <div class="col-md-6 col-12">
                      </div>
                    </div>
                    <div class="row" v-if="item.policyType === 1">
                      <div class="col-md-6 col-12">
                        <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                          ::label="$t('getPartPersonLabel')" prop="partPersonName">
                          <el-input v-model="item.partPersonName"></el-input>
                        </el-form-item>
                        <el-form-item
                          v-if="item.damageCategoryId && item.damageCategoryId !== 1 && item.damageCategoryId !== 2"
                          :label="$t('Əmlak_adı')" prop="propertyName">
                          <el-input v-model="item.propertyName"></el-input>
                        </el-form-item>
                      </div>
                      <div class="col-md-6 col-12">
                        <el-form-item v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                          ::label="$t('getPartPersonPhoneLabel')" prop="partPersonPhone">
                          <phone v-model="item.partPersonPhone" />
                        </el-form-item>
                      </div>
                    </div>
                    <titles :text="$t('Ödəniş_məlumatları')"></titles>
                    <hr width="100%" size="50"
                      style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;" align="center">
                    <div class="row">
                      <div class="col-md-6 col-12">
                        <el-form-item :label="$t('Ödənilmə_qaydası')" prop="paymentRule">
                          <el-select style="width: 100%" :placeholder="$t('Seçin')" size="small"
                            v-model="item.paymentRule">
                            <el-option :label="$t('Bank_hesabı')" :value="2"></el-option>
                            <el-option :label="$t('Kart')" :value="1"></el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                      <div class="col-md-6 col-12">
                        <el-form-item :label="$t('Yekun_məbləğ')" prop="paymentSum">
                          <el-input v-decimal :disabled="true" v-model="item.paymentSum"></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 col-12">
                        <el-form-item :label="$t('Əlavə_qeyd')" prop="otherDescr">
                          <el-input v-model="item.otherDescr" resize="none" type="textarea" :rows="2">
                          </el-input>
                        </el-form-item>
                      </div>
                    </div>
                  </el-form>
                </card>
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-loading="loading" value="1">
              <el-collapse-item name="1">
                <template #title>
                  <div style="margin-left: 7px;">
                    <i class="fa-solid fa-headphones-simple"></i>
                    &nbsp;
                    <span>{{$t('Çağrı_mərkəzinin_qeydləri')}}</span>
                  </div>
                </template>
                <accident-base :value="accItem"></accident-base>
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-loading="loading" value="2">
              <el-collapse-item name="2">
                <template #title>
                  <div style="margin-left: 7px;">
                    <i class="fa-solid fa-person-military-pointing"></i>
                    &nbsp;
                    <span>{{$t('Komissarın_qeydləri')}}</span>
                  </div>
                </template>
                <accident-comm-base :value="comm"></accident-comm-base>
              </el-collapse-item>
            </el-collapse>
            <el-collapse v-loading="loading" value="3">
              <el-collapse-item name="3">
                <template #title>
                  <div style="margin-left: 7px;">
                    <i class="fa-solid fa-people-arrows-left-right"></i>
                    &nbsp;
                    <span>{{$t('İştirakçılar')}}</span>
                  </div>
                </template>
                <card>
                  <el-form v-loading="partloading">
                    <div class="row">
                      <div class="col-md-6 col-12" v-for="participant in participants" :key="participant.id">
                        <div v-if="participant.policyType === null || participant.policyType === 1">
                          <participant-card :item="participant" :readonly="true" @refresh="getParticipants"
                            @edit="editParticipant(participant.id)" @delete="deleteParticipant"
                            @report="reportParticipant(participant.id)" />
                        </div>
                        <div v-else>
                          <other-participant-card :item="participant" :readonly="true" @refresh="getParticipants"
                            @edit="editParticipant(participant.id)" @delete="deleteParticipant"
                            @report="reportParticipant(participant.id)" />
                        </div>
                      </div>
                    </div>
                  </el-form>
                </card>
              </el-collapse-item>
            </el-collapse>
          </card>
        </el-tab-pane>
        <el-tab-pane name="claimdoc" :label="$t('Sənədlər')">
          <div>
            <claim-docs :readonly="true" v-if="item.id" :id="item.id"></claim-docs>
          </div>
        </el-tab-pane>
        <el-tab-pane name="act" :label="$t('Hesab_məlumatları')">
          <div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-10">
                <el-button size="small" type="warning" @click="onStartPay" v-if="!act">
                  <i class="fa-solid fa-play"></i>
                  {{$t('Qəbul_et_və_başla')}}
                </el-button>
                <div v-else>
                  <span style="background-color:#8E9A9B; color: white; padding:5px;">
                    {{ "Hesab məlumatlarının daxil edilməsi başlanmışdır: " + (act.createdBy || '') }}
                  </span><br />
                </div>
              </div>
            </div>
            <bank-account-info :value="act" v-if="act && act.length !== 0" @refresh="getData"
              :actPrint="actPrint" :policyType="item.policyType" />
          </div>
          <br />
        </el-tab-pane>
        <el-tab-pane name="expert" v-if="oSdamageType !== 2" :label="$t('Qiymətləndirmə')">
          <div>
            <div class="row">
              <div class="col-md-10 col-12">
                <div style="padding-bottom: 10px">
                  <div v-if="techExpertStatus">
                    <span style="background-color:#8E9A9B; color: white; padding:5px;">
                      {{ "İş texniki ekspertizaya göndərilmişdir: " + (techExpertStatus.createdBy || '') }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="techExpertStatus">
              <assessments @refresh="getData" :claimId="Number(id)" :readonly="false" />
              <assessments @refresh="getClaimTechExpert" :claimId="Number(id)" :readonly="true" />
              <internal-evaluation @refresh="getData" :value="expertItem" :readonly="true" />
            </div>
            <div v-if="techExpertStatus && item.policyType === 1">
              <service-evaluation @refresh="getClaimTechExpert" :readonly="true" :value="expertItem" />
            </div>
            <div v-if="techExpertStatus">
              <indepentend-evaluation @refresh="getClaimTechExpert" :readonly="true" :value="expertItem" />
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="aprrove" :label="$t('Təsdiqlənmə')">
          <card>
            <div>
              <signers v-if="item.id" :value="item.id"></signers>
            </div>
          </card>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <el-dialog :visible.sync="rejectVisible" width="30%" top="30vh" :title="$t('Səbəb')">
      <el-input v-model="rejectItem.reason" :placeholder="$t('Səbəb')"></el-input>
      <div style="height: 20px;"></div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="checkReasonBeforeConfirm()">{{$t('Bəli')}}</el-button>
        <el-button size="small" @click="rejectVisible = false">{{$t('Xeyr')}}</el-button>
      </span>
    </el-dialog>

    <participant ref="participant" @saved="getParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
    <other-participant ref="otherParticipant" @saved="getParticipants" />
  </div>
</template>

<script>
import Phone from "../components/Phone.vue";
import OtherParticipant from "../components/OtherParticipant.vue";
import OtherParticipantCard from "../components/OtherParticipantCard.vue";
import DamageCategories from "../components/DamageCategories.vue";
import BankAccountInfo from '../components/BankAccountInfo.vue';
import ClaimDocs from "../components/ClaimDocs.vue";
import Signers from "../components/Signers.vue";
import Assessments from "../components/Assessments.vue";
import MedDamageTypes from "../components/MedDamageTypes.vue";
import Participant from "../components/Participant.vue";
import ParticipantCard from "../components/ParticipantCard.vue";
import AccidentBase from "../components/AccidentBase.vue";
import AccidentCommBase from "../components/AccidentCommBase.vue";
import ReportParticipant from "../components/ReportParticipant.vue";
import InternalEvaluation from '../components/InternalEvaluation.vue';
import ServiceEvaluation from "../components/ServiceEvaluation.vue";
import IndepentendEvaluation from '../components/IndepentendEvaluation.vue';
import { labelPosition, formatDateTime } from "../../services/helper";
import { asanapi } from "../../services/sales";
import {
  GetClaimParticipant,
  GetClaimActPrint,
  CheckStatusCount,
  LastAssessmentStatus
} from "../../services/common";
import {
  GetAccident,
  GetCommData,
  GetParticipants,
  GetAccidentsByStatus
} from "../../services/accident";
import {
  GetClaim,
  UpdateClaim,
  DeleteClaimDoc,
  SendToTechExpert,
  GetClaimTechExpert,
  CreateClaimPay,
  GetClaimPayment,
  GetClaimAct,
  SendToLegalExpert,
  LastClaimStatus,
  SendToApprove,
  UpdateActApproval,
  LastActApprovalStatus,
  ClaimPaymentFinish,
  GetPaymentReject,
  PaymentReject,
} from "../../services/claim";
import Titles from "../components/Titles.vue";

export default {
  components: {
    Titles,
    ClaimDocs,
    DamageCategories,
    BankAccountInfo,
    Signers,
    Phone,
    InternalEvaluation,
    ServiceEvaluation,
    IndepentendEvaluation,
    AccidentBase,
    AccidentCommBase,
    Participant,
    ParticipantCard,
    ReportParticipant,
    OtherParticipant,
    OtherParticipantCard
  },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      activeName: "descr",
      loading: false,
      claimLoading: false,
      item: {},
      participants: [],
      claimdocs: [],
      accItem: {},
      search: "",
      claimParticipants: {},
      fileStatus: 0,
      techExpertStatus: null,
      legalExpertStatus: null,
      expertItem: {},
      actLoading: false,
      act: null,
      actPrint: {},
      claimStatus: null,
      oSdamageType: 1,
      medExpert: {},
      statusCount: 0,
      uid: this.$store.state.user.id,
      asanData: {
        Personal: {},
        Voen: {},
      },
      rejectVisible: false,
      rejectClaim: [],
      assessmentStatus: null,
      printDialogVisible: false,
      comm: {},
      partloading: false,
      approvals: {},
      roles: this.$store.state.user.roles,
      payment: null,
      claimId: this.id,
      rejectItem: {},
      labelPosition: labelPosition,
    };
  },
  computed: {
    getIdentLabelName() {
      return this.item.partPersonType === 1 ? this.$t('FİN') : this.$t('VÖEN');
    },
    getPartPersonLabel() {
      return this.item.partPersonType === 1 ? this.$t('Şəxs') : this.$t('Qurum');
    },
    getPartPersonPhoneLabel() {
      return this.item.partPersonType === 1 ? this.$t('Əlaqə') : this.$t('Əlaqə');
    }
  },
  methods: {
    formatDateTime,
    
    async getClaimAct() {
      try {
        const response = await GetClaimAct(this.claimId);
        this.act = response.data.data?.[0] || null;
      } catch (error) {
        this.act = null;
      }
    },
    
    hasRoles(requiredRoles) {
      return requiredRoles.some(role => this.roles.includes(role));
    },
    
    async lastAssessmentStatus() {
      try {
        const response = await LastAssessmentStatus(this.claimId);
        if (response.data.data) {
          this.assessmentStatus = response.data.data;
        }
      } catch (error) {
      }
    },

    editParticipant(id) {
      if (this.item.policyType === 1) {
        this.$refs.participant.edit(id, true);
      } else {
        this.$refs.otherParticipant.edit(id, true);
      }
    },

    reportParticipant(id, accidentId, createUserId) {
      this.$refs.report.edit(id, accidentId, createUserId);
    },
    
      async getCommData() {
      this.commloading = true;
      try {
        const response = await GetCommData(this.item.accidentId);
        this.comm = response.data.data?.[0] || null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Komissar_məlumatları_gətirilərkən_səhv_baş_verdi') });
        this.comm = null;
      } finally {
        this.commloading = false;
      }
    },
    
    async getClaimActPrint() {
      try {
        const response = await GetClaimActPrint(this.claimId);
        if (response.data?.data) {
          this.actPrint = response.data.data?.[0] || {};
        }
      } catch (error) {
      }
    },

    onStartPay() {
      this.$confirm(
        this.$t('Ödənişin_daxil_edilməsi_başlanır'),
        this.$t('Təsdiqləyin'),
        {
          confirmButtonText: this.$t('Bəli'),
          cancelButtonText: this.$t('Xeyr'),
          type: "info",
        }
      ).then(async () => {
        try {
          const response = await CreateClaimPay(this.claimId, this.uid);
          if (response.data && response.data.isSuccess) {
            this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
            this.getData();
          } else {
            this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
          }
        } catch (error) {
          this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
        }
      });
    },
    
    async getStatusTechExpert() {
      try {
        const response = await GetAccidentsByStatus(0, this.claimId, 70, this.uid);
        this.techExpertStatus = response.data.data?.[0] || null;
      } catch (error) {
        this.techExpertStatus = null;
      }
    },
    
    onFinishPay() {
      this.$confirm(
        this.$t('Ödənişin_yekunlaşdırmaq_istəyirsiniz'),
        this.$t('Təsdiqləyin'),
        {
          confirmButtonText: this.$t('Bəli'),
          cancelButtonText: this.$t('Xeyr'),
          type: "info",
        }
      ).then(async () => {
        try {
          const response = await ClaimPaymentFinish(this.claimId, this.uid);
          if (response.data.data) {
            this.$message({ type: "success", message: this.$t('Ödəniş_olundu') });
            this.getData();
            this.$router.push('/payment/main');
          } else {
            this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
          }
        } catch (error) {
          this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
        }
      });
    },

    async getParticipants() {
      this.partloading = true;
      try {
        const response = await GetParticipants(this.item.accidentId);
        if (response.data) {
          this.participants = response.data.data || [];
        }
      } catch (error) {
        this.$message({ type: "error", message: this.$t('ştirakçılar_gətirilərkən_səhv_baş_verdi_1') });
      } finally {
        this.partloading = false;
      }
    },

    async getClaimTechExpert() {
      try {
        const response = await GetClaimTechExpert(this.claimId);
        if (response.data.data) {
          this.expertItem = response.data.data?.[0] || null;
          await this.lastAssessmentStatus();
        }
      } catch (error) {
      }
    },

    async getClaimPayment() {
      try {
        const response = await GetClaimPayment(this.claimId);
        if (response.data) {
          this.payment = response.data.data?.[0] || null;
        }
      } catch (error) {
        this.payment = null;
      }
    },

    async getData() {
      this.loading = true;
      try {
        const response = await GetClaim(this.id);
        if (response.data) {
          this.item = response.data.data?.[0] || {};
          
          await Promise.all([
            this.getClaimTechExpert(),
            this.getStatusTechExpert(),
            this.getClaimPayment(),
            this.getClaimAct(),
            this.getClaimActPrint(),
            this.getAccident(),
            this.lastAssessmentStatus(),
            this.getCommData(),
            this.getParticipants(),
            this.lastClaimStatus(),
            this.getPaymentReject()
          ]);
        } else {
          this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
        }
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Bir_səhv_baş_verdi') });
      } finally {
        this.loading = false;
      }
    },

    openDialog() {
      this.rejectVisible = true;
    },

    checkReasonBeforeConfirm() {
      if (!this.rejectItem.reason) {
        this.$message({ type: "warning", message: this.$t('Səbəb_yazılmayıb') });
        return;
      }
      if (this.claimStatus === 153) {
        this.$message({ type: "warning", message: this.$t('Daha_öncə_geri_qaytarılıb') });
        return;
      }
      this.rejectPayment();
    },

    async rejectPayment() {
      this.loading = true;
      this.rejectItem.id = this.id;
      this.rejectItem.commandUserId = this.uid;
      this.rejectItem.rejectType = 4;
      
      try {
        const response = await PaymentReject(this.rejectItem);
        if (response.data.data) {
          this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
          this.$router.push('/payment/main');
        } else {
          this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
        }
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
      } finally {
        this.loading = false;
        this.getData();
      }
    },

    async getPaymentReject() {
      try {
        const response = await GetPaymentReject(this.id, 4);
        if (response.data.data) {
          this.rejectClaim = response.data.data;
        }
      } catch (error) {
      }
    },

    async getAccident() {
      this.loading = true;
      try {
        const response = await GetAccident(this.item.accidentId);
        if (response.data.data) {
          this.accItem = response.data.data?.[0] || null;
        }
      } catch (error) {
        this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
      } finally {
        this.loading = false;
      }
    },

    async lastClaimStatus() {
      try {
        const response = await LastClaimStatus(this.claimId);
        if (response) {
          this.claimStatus = response.data;
        }
      } catch (error) {
        this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
      }
    },

 
  },
  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
  pointer-events: none;
}
</style>